import { render, staticRenderFns } from "./InfoVcDemo.vue?vue&type=template&id=59669bdb&scoped=true&"
import script from "./InfoVcDemo.vue?vue&type=script&lang=js&"
export * from "./InfoVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./InfoVcDemo.vue?vue&type=style&index=0&id=59669bdb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59669bdb",
  null
  
)

export default component.exports